// @flow

import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { v1 as uuid } from 'uuid';
import type { OnboardingRouteProps } from '../../../types/OnboardingRouteProps';
import { setOnboardingActionCreators } from '../../../store/actions/onboarding';
import type { UserOnboarding } from '../../../types/UserOnboarding';
import type { AuthState } from '../../../store/reducer/auth';
import isSocialLogin from '../../../modules/isSocialLogin';

type StateToProps = {|
  onboardingUser: UserOnboarding,
  auth: AuthState,
  userEmail: string,
  userPassword: string,
  userFirstName: string,
  userLastName: string,
|}

const mapStateToProps = ({ onboarding: onboardingUser, auth }): StateToProps => {
  const socialLogin = isSocialLogin(auth);

  return {
    onboardingUser,
    auth,
    userEmail: socialLogin ? _get(auth, 'socialLogin.email') : onboardingUser.email,
    userPassword: socialLogin ? uuid() : onboardingUser.password,
    userFirstName: socialLogin ? _get(auth, 'socialLogin.firstName', '') : onboardingUser.firstName,
    userLastName: socialLogin ? _get(auth, 'socialLogin.lastName', '') : onboardingUser.firstName,
  };
};

type DispatchProps = typeof setOnboardingActionCreators;
const mapDispatchToProps = (dispatch): {|
  onboardingActions: DispatchProps,
|} => ({
  onboardingActions: bindActionCreators(setOnboardingActionCreators, dispatch),
});

export type OnboardingProps = {|
  ...OnboardingRouteProps,
  ...StateToProps,
  onboardingActions: DispatchProps,
|};

export default function withOnboarding<OwnProps: ?{} = {}>(Component: React.AbstractComponent<{| ...OwnProps, ...OnboardingProps |}>) {
  return connect(mapStateToProps, mapDispatchToProps)(Component);
}
